export * from './job-animal-table.component';
export * from './job-cohort-table.component';
export * from './job-sample-table.component';
